"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M5.92,17.59a1.68,1.68,0,0,0,3.35,0Zm7.47-3.53V9.16A5.79,5.79,0,0,0,8.94,3.53V2.92a1.34,1.34,0,0,0-2.68,0v.61A5.79,5.79,0,0,0,1.8,9.16v4.9L0,15.85v.89H15.18v-.89Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M23,16H17.08a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h1.48v1.23a.25.25,0,0,0,.15.23l.09,0a.25.25,0,0,0,.17-.07l1.41-1.41H23a1,1,0,0,0,1-1V17A1,1,0,0,0,23,16ZM18.8,18.72a.25.25,0,1,1,.25-.25A.25.25,0,0,1,18.8,18.72Zm1.23,0a.25.25,0,1,1,.25-.25A.25.25,0,0,1,20,18.72Zm1.23,0a.25.25,0,1,1,.25-.25A.25.25,0,0,1,21.27,18.72Z"
  })));
};

exports["default"] = _default;